export const showNotification = (
  notificationType,
  message,
  withTimeout = true
) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SHOW_NOTIFICATION',
      notificationType,
      message,
    })
    if (withTimeout) {
      setTimeout(() => {
        dispatch(hideNotification())
      }, 2000)
    }
  }
}
export const hideNotification = (notificationType, message) => {
  return {
    type: 'HIDE_NOTIFICATION',
  }
}
